import { compose, withHandlers } from "recompose";

import NotificationProvider from "../../elements/NotificationContent/Notifications";
import Queries from "../../queries/queries2";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";

import { getTiersXtraData, setTiersXtraData } from "../../tools/tiersExtraData";

const notifications = withHandlers({
  sendNotification: ({ sendNotification }) => content => {
    sendNotification && sendNotification(content);
  },
  sendSuccessCreateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = intl.formatMessage({ id: "ids_clientHasBeenCreated" });
    sendNotification && sendNotification(notif);
  },
  sendFailureCreateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = intl.formatMessage({
      id: "ids_clientCreateFailed_notification"
    });
    sendNotification && sendNotification(notif);
  },
  sendSuccessUpdateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = intl.formatMessage({ id: "ids_clientHasBeenUpdated" });
    sendNotification && sendNotification(notif);
  },
  sendFailureUpdateNotification: ({ sendNotification, intl }) => () => {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = intl.formatMessage({
      id: "ids_clientUpdateFailed_notification"
    });
    sendNotification && sendNotification(notif);
  }
});

const handlers = withHandlers({
  deleteClients: () => async data => {
    alert("not implemented yet");
    console.log("deleteClients", data);
  },
  createClient: ({
    companyId,
    sendSuccessCreateNotification,
    sendFailureCreateNotification,
    createClientMutation,
    connectClientMutation,
    updateClientMutation
  }) => async values => {
    values["companyId"] = companyId;
    if (values.taxIdemCompany) {
      values["tax1Id"] = "";
      values["tax2Id"] = "";
    } else {
      values["tax1Id"] = values.tax1 && values.tax1.id;
      values["tax2Id"] = values.tax2 && values.tax2.id;
    }

    values["xtraData"] = setTiersXtraData(null, values.taxableValue, values.externalCodeValue, values.escomptePercentValue)

    values["collaboratorRespComId"] =
      values.tiersRespCom &&
      values.tiersRespCom.tiers &&
      values.tiersRespCom.tiers.collaborator &&
      values.tiersRespCom.tiers.collaborator.id;

    // values["language"] = values.language;
    values["dateLanguage"] = values.dateLanguage
      ? values.dateLanguage
      : values.language;

    console.log("VALUES BEFORE CLIENT CREATE", values);
    try {
      const mutation = await createClientMutation({
        variables: values
      });

      if (!values.taxIdemCompany || !!values["collaboratorRespComId"]) {
        // tax connection
        values["id"] = mutation.data.createTiers.client.id;
        values["connectTax1"] = !!values.tax1;
        values["disconnectTax1"] = false;
        values["connectTax2"] = !!values.tax2;
        values["disconnectTax2"] = false;

        // collaborator connection
        values["disconnectCollaboratorRespComId"] = false;
        values["connectCollaboratorRespComId"] = !!values[
          "collaboratorRespComId"
        ];

        console.log("VALUES BEFORE CLIENT CONNECT", values);
        const connected = await connectClientMutation({
          variables: values
        });
        console.log("AFTER CLIENT CONNECT", connected);
      }
      sendSuccessCreateNotification();
      return mutation;
    } catch (e) {
      console.log(e);
      sendFailureCreateNotification();
    }
  },
  updateClient: ({
    sendSuccessUpdateNotification,
    sendFailureUpdateNotification,
    updateClientMutation,
    connectClientMutation,
    updateAddress,
    connectAddress,
    createAddress
  }) => async values => {

    // console.log("116 - values=", values);
    
    values["tax1Id"] = values.tax1 && values.tax1.id;
    values["tax2Id"] = values.tax2 && values.tax2.id;
    values["currencyId"] = values.currency;
    values["languageId"] = values.language;
    values["dateLanguageId"] = values.dateLanguage
      ? values.dateLanguage
      : values.language;
    const vars = {
      address: values.address || "",
      companyId: values.company,
      countryId: values.country,
      tiersId: values.id,
      group: values.group
    };
    try {
      if (values["addressId"]) {
        // update address
        vars.addressId = values["addressId"];
        // console.log('update Address vars', vars);
        await updateAddress({ variables: vars });
        vars["connectCountry"] = values.country !== null;
        await connectAddress({ variables: vars });
      } else {
        // create new Address
        // console.log('newAddress vars', vars);
        const newAddress = await createAddress({
          variables: vars
        });
        values.addressId = newAddress.data.createAddress.id;
        vars["connectCountry"] = values.country !== null;
        await connectAddress({ variables: vars });
      }
      //console.log("updateClient - VALUES BEFORE CLIENT UPDATE", values);
      const mutation = await updateClientMutation({
        variables: values,
        refetchQueries: [
          {
            query: Queries.GET_CLIENT,
            variables: { id: values.id }
          },
          { 
            query: Queries.GET_CLIENT_CONNECTION,
            variables: {
              companyId: values.company,
              tiersId: values.id
            }
          },
          { 
            query: Queries.GET_CLIENT_CONNECTION,
            variables: {
              companyId: values.company,
              tiersId: ""
            }
          }
        ]
      });
      values["id"] = mutation.data.updateClient.id;
      await connectClientMutation({ variables: values });
      sendSuccessUpdateNotification();
      return mutation;
    } catch (e) {
      console.log(e);
      sendFailureUpdateNotification();
    }
  }
});

export default compose(
  injectIntl,
  graphql(Queries.CREATE_CLIENT_MUTATION, { name: "createClientMutation" }),
  graphql(Queries.CONNECT_CLIENT_MUTATION, { name: "connectClientMutation" }),
  graphql(Queries.UPDATE_CLIENT_MUTATION, { name: "updateClientMutation" }),
  graphql(Queries.updateAddress, { name: "updateAddress" }),
  graphql(Queries.connectAddress, { name: "connectAddress" }),
  graphql(Queries.createAddress, { name: "createAddress" }),
  notifications,
  handlers
);
